import { render, staticRenderFns } from "./ApprovedFormIcon.vue?vue&type=template&id=64bdc699&scoped=true"
import script from "./ApprovedFormIcon.vue?vue&type=script&lang=ts"
export * from "./ApprovedFormIcon.vue?vue&type=script&lang=ts"
import style0 from "./ApprovedFormIcon.vue?vue&type=style&index=0&id=64bdc699&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdc699",
  null
  
)

export default component.exports